import { createAction, props } from '@ngrx/store';
import { SmsTemplate } from './sms-template.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records sms template'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records sms template success', 
    props<{ listData: SmsTemplate[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records sms template failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record sms template',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record sms template success', 
    props<{ singleData: SmsTemplate }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record sms template failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record sms template',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record sms template success'
);
export const addRecordFailure = createAction(
    '[Data] Add record sms template failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record sms template',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record sms template success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record sms template failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record sms template',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record sms template success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record sms template failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state sms template',
);